<template>
  <transition @enter="enter" @leave="leave" appear>
    <div v-show="!hidden" class="game-count-down count-down">
      <span>{{ timeLeft }}</span>
    </div>
  </transition>
</template>

<script>
import anime from '@/assets/libs/anime';

export default {
  name: 'GameCountdown',

  data() {
    return {
      timeLeft: 15,
      tId: -1,
      hidden: true,
    };
  },

  mounted() {
    this.$eventHub.$on('count-down-reset', this.reset);
    this.$eventHub.$on('count-down-start', this.start);
    this.$eventHub.$on('count-down-stop', this.stop);
  },

  methods: {
    reset() {
      clearInterval(this.tId);
      this.timeLeft = 10;
    },
    start() {
      this.reset();
      this.hidden = false;
      this.tId = setInterval(() => {
        this.timeLeft -= 1;

        if (this.timeLeft <= 0) this.timeUp();
      }, 1000);
    },
    stop() {
      this.hidden = true;
      clearInterval(this.tId);
    },
    timeUp() {
      this.hidden = true;
      this.$store.dispatch('checkAnswer', -1);
      this.$eventHub.$emit('count-down-stop');
    },
    enter(el, done) {
      anime({
        targets: el,
        scale: [0, 1],
        rotate: [25, 0],
        duration: 700,
        easing: 'cubicBezier(.5,0,0,1)',
        complete: done,
      });
    },
    leave(el, done) {
      anime({
        targets: el,
        scale: [1, 0],
        rotate: [0, -25],
        duration: 700,
        easing: 'cubicBezier(.5,0,0,1)',
        complete: done,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.count-down {
  position: absolute;
  top: calc(var(--unit-vw) * 2);
  right: calc(var(--unit-vw) * 0.3);
  width: calc(162px * var(--rw));
  height: calc(162px * var(--rw));

  background-image: url('/img/svg/sad-background.svg');
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;

  display: flex;
  align-items: center;
  justify-content: center;

  @include mq($until: ipadP) {
    top: auto;
    left: auto;
    bottom: 5px;
    right: calc(var(--unit-vw) * 0.5);
    width: calc(100px * var(--rw));
    height: calc(100px * var(--rw));
  }

  & span {
    @extend %font-size-question;
    color: $color-white;
  }
}
</style>
